// removed by extract-text-webpack-plugin
module.exports = {"dropzone":"_2mjFl","title":"_2suEY","details":"_1ibGR","dropzoneIcon":"DsLz0","underDropzone":"_1_NKo","toUpload":"_3mYgN","fileIcon":"_3pj4n","fileSize":"_3aL_o","uploaded":"T1G4l","loadingIndicator":"_3OKWs","progress":"_1wPvI","deleteIcon":"_1DTwI","tooBig":"nQ5wD","tooBigIcon":"_352oI","disabled":"_3RVhA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FileUploader/FileUploader.scss
// module id = 2505
// module chunks = 0